import React from "react";
import { useDroppable } from "@dnd-kit/core";

export default function InventorySlot({
    zone,
    index,
    accept,
    className = "",
    "aria-label": ariaLabel,
    children,
}) {
    const id =
        zone === "armor" ? `slot-armor-${accept}` : `slot-${zone}-${index}`;

    const { setNodeRef, isOver } = useDroppable({
        id,
        data: { type: "slot", zone, index, accept },
    });

    return (
        <div
            ref={setNodeRef}
            className={`vip-sim-slot ${isOver ? "vip-sim-slot--over" : ""} ${className}`.trim()}
            aria-label={ariaLabel}
        >
            {children}
        </div>
    );
}
